import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-survey.component.scss';
var FormItemSurvey = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemSurvey, _super);
    function FormItemSurvey(element) {
        return _super.call(this, element) || this;
    }
    FormItemSurvey.prototype.init = function () {
        this.applyForm = this.element.querySelector('form');
        this.applyFormSubmit = Array.from(this.element.querySelectorAll('.js-submit__survey'));
        this.subjectField = this.element.querySelector('input[name=subject]');
        this.emailField = this.element.querySelector('input[name=email]');
        this.recipientField = this.element.querySelector('input[name=recipient]');
        this.closeButton = Array.from(this.element.querySelectorAll('.survey--close-modal'));
    };
    FormItemSurvey.prototype.bindEvents = function () {
        var _this = this;
        this.applyFormSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.applyForm) {
            var _formFields = Array.from(this.applyForm.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        if (this.closeButton) {
            this.closeButton.map(function (item) { return item.addEventListener('click', function (event) {
                _this.closeModals();
            }); });
        }
        // Reset the form
        this.applyForm.addEventListener('custom_form_reset_event', function (e) {
            _this.resetForm();
        }, false);
    };
    FormItemSurvey.prototype.resetForm = function () {
        if (this.applyForm) {
            this.applyForm.reset();
            var formContainerFields = this.element.querySelector('.form__fields--container');
            if (formContainerFields) {
                formContainerFields.classList.remove('hidden');
            }
            var formContainerSuccess = this.element.querySelector('.form__success--container');
            if (formContainerSuccess) {
                formContainerSuccess.classList.remove('active');
            }
        }
    };
    FormItemSurvey.prototype.closeModals = function () {
        var _allModals = Array.from(document.querySelectorAll('.js-apply-now-modal'));
        _allModals.forEach(function (_modal) {
            _modal.classList.add('modal--closed');
            _modal.classList.remove('modal--close');
        });
    };
    FormItemSurvey.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var fieldsContainer = form.querySelector('.form__fields--container');
        var success = form.querySelector('.form__success--container');
        // fields
        var postData = "";
        var email = form.querySelector("input[name=email]");
        postData += "email=" + (email ? email.value : '');
        var recipient = form.querySelector("input[name=recipient]");
        postData += "&recipient=" + (recipient ? recipient.value : '');
        var subject = form.querySelector("input[name=subject]");
        postData += "&subject=" + (subject ? subject.value : '');
        var description = form.querySelector("input[name=description]");
        postData += "&description=" + (description ? description.value : '');
        var experience = form.querySelector("textarea[name=better-experience]");
        postData += "&better-experience=" + (experience ? experience.value : '');
        var difficulties = form.querySelector("textarea[name=difficulties]");
        postData += "&difficulties=" + (difficulties ? difficulties.value : '');
        var contactMethod = form.querySelector("input[name=contact-method]:checked");
        postData += "&contact-method=" + (contactMethod ? contactMethod.value : '');
        var shareInformation = form.querySelector("textarea[name=share-information]");
        postData += "&share-information=" + (shareInformation ? shareInformation.value : '');
        if ((experience && experience.value !== '') || (difficulties && difficulties.value !== '') || (contactMethod && contactMethod.value !== '') || (shareInformation && shareInformation.value !== '')) {
            // loader + hide form
            loader.classList.add('active');
            fieldsContainer.classList.add('hidden');
            // variables
            var analyticsService_1 = new AnalyticsService();
            var url = this.baseUrl + '/services/genericform.jsp';
            // service
            this.formsService.postForm(url, postData).then(function (response) {
                // service ok
                loader.classList.remove('active');
                analyticsService_1.dtmFormComplete('complete', '');
                if (success) {
                    success.classList.add('active');
                }
            }).catch(function (response) {
                // service failed
                analyticsService_1.dtmFormComplete('complete', 'failed');
                loader.classList.remove('active');
                if (success) {
                    success.classList.add('active');
                }
            });
        }
    };
    return FormItemSurvey;
}(Base));
export { FormItemSurvey };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-survey/form-item-survey.component.ts
// module id = 974
// module chunks = 0